import React, { Dispatch, SetStateAction } from 'react';
import classes from './../Auth.module.scss';
import { BoxNotification } from '../../../components/containers/BoxNotification';

export type CheckEmailViewProps = {
  //
  email: string;
  setResetSent: Dispatch<SetStateAction<boolean>>;
};

export const CheckEmailView = (props: CheckEmailViewProps): JSX.Element => {
  return (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Check Your Email</h2>
      </div>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'info'}>
          <p>
            We sent password reset instructions to <strong>{props.email}</strong>. If it does not arrive soon, please
            check your spam folder, or{' '}
            <a onClick={() => props.setResetSent(false)}>
              <strong>try re-sending the email</strong>
            </a>
            .
          </p>
          <p>
            Need help?{' '}
            <a href={'/contact'} target={'_blank'} rel="noreferrer">
              Contact us.
            </a>
          </p>
        </BoxNotification>
      </div>
    </div>
  );
};
